// extracted by mini-css-extract-plugin
export default {"backgroundColor":"dashboard_backgroundColor__4TLPQ","nohover":"dashboard_nohover__03-28","datefont":"dashboard_datefont__-Ff+6"};